import { createContext } from 'react';
import GlobalState from '../interfaces/GlobalStateInterface';
import { TRANSCRIPTS_CATEGORIES } from '../constants';

const GlobalStateContext = createContext<GlobalState>({
  userDetails: {
    isPending: true,
    error: null,
    data: undefined,
  },
  allEoas: {
    isPending: true,
    error: null,
    data: undefined,
  },
  schools: {
    isPending: true,
    error: null,
    data: undefined,
  },
  demographicCategories: {
    isPending: true,
    error: null,
    data: undefined,
  },
  schoolsConfig: {
    isPending: true,
    error: null,
    data: undefined,
  },
  transcriptSelectionSchool: '',
  dataQcSchool: '',
  uploadProgressSummary: {
    isPending: true,
    error: null,
    data: {
      pending: [],
      progress: [],
      completed: [],
    },
  },
  uploadProgressByCategory: {},
  schoolsUploadProgressByCategory: {},
  updateTranscriptSelectionSchool: () => {},
  updateDataQcSchool: () => {},
  switchEoa: async () => {},
  requiresDistrictSelection: false,
  completeDistrictSelection: async () => {},
  pubNubToken: '',
  refreshUploadProgress: () => {},
  uploadRequirements: [],
  lastNavigatedTranscriptSelectionPage: {
    current: {
      [TRANSCRIPTS_CATEGORIES.RIGOROUS_ACADEMIC]: 1,
      [TRANSCRIPTS_CATEGORIES.ON_THE_CUSP]: 1,
      [TRANSCRIPTS_CATEGORIES.STRUGGLING]: 1,
    },
  },
});

export default GlobalStateContext;
